import { axiosWrapper } from "../../axios_old"
import { Data, getCurrency } from "../../formating"
import store from "../../../store"

const _handleGetNotificationMessage = ({ data, balances = {}, user }) => {
	const expenseAmount = data.amount
	const formattedExpenseAmount = getCurrency({
		actions: ["divide"],
		amount: expenseAmount
	})

	const { allocationType, allocatedAmount } = data
	let processedAmount = allocatedAmount
	let msg = ""

	if (allocationType === "fsaReimbursement" || allocationType === "hraReimbursement") {
		let planName = data.planName
		msg = `${formattedExpenseAmount} submitted for reimbursement from your ${planName}`
	} else {
		msg = `Your expense for ${formattedExpenseAmount} has been saved.`
	}

	return msg
}

const expense = async (args) => {
	const { user, data, action, setNotification, history, balances, original, stitchingData, options, setMounted } = args

	try {
		let newData = { allocatedAmount: 0 }

		if (action === "GET_ALL") {
			const {
				data: { data: expensesAPI }
			} = await axiosWrapper(
				"GET",
				`expense/v2?includeProvider=true&includePatient=true&includeProcessed=${Boolean(
					options?.includes("processed")
				)}&includeUnallocated=true`,
				null,
				null,
				user.token
			)

			const exps = new Map()
			const providers = new Map()
			const patients = new Map()

			expensesAPI.forEach((expense) => {
				if (expense.providerId) {
					providers.set(expense.providerId, Data.Provider({ provider: expense.provider }))
				}
				if (expense.patientId) {
					patients.set(expense.patientId, Data.Dependent({ dependent: expense.patient }))
				}

				const formattedExpense = Data.Expense({
					expense,
					patients,
					providers,
					bankAccounts: stitchingData?.bankAccounts
				})

				exps.set(expense.id, formattedExpense)
			})
			return exps
		} else if (action === "GET_ONE") {
			const { data: expensesAPI } = await axiosWrapper(
				"GET",
				`expense/v2/${data.id}?includePatient=true&includeProvider=true`,
				null,
				null,
				user.token
			)

			return expensesAPI
		} else if (action === "CREATE") {
			const { data: retData } = await axiosWrapper("POST", `expense/v2`, data, null, user.token)
			newData = retData
		} else if (action === "UPDATE") {
			const { data: retData } = await axiosWrapper("PATCH", `expense/v2/${data.id}`, data, null, user.token)

			const allocationPayload = {
				amount: 0,
				targetAccountId: ""
			}

			if (data.allocatedAmount > 0) allocationPayload.amount = data.allocatedAmount

			if (data.allocationType === "saveAsYouGo") allocationPayload.targetAccountId = "saveAsYouGo"
			else if (data.allocationType === "withdrawal") allocationPayload.targetAccountId = data.targetAccountId

			if (allocationPayload.amount > 0) {
				await axiosWrapper(
					"POST",
					`expense/v2/${data.id}/plan/${data.targetPlan.id}/allocation`,
					allocationPayload,
					null,
					user.token
				)
			}

			const msg = _handleGetNotificationMessage({
				data,
				balances,
				user
			})

			if (setNotification) {
				setTimeout(async () => {
					await store.setNotification("notification", true, {
						msg,
						severity: "success",
						isPersist: true
					})
				}, 200)
			}
		} else if (action === "UPDATE_ALLOCATION") {
			await axiosWrapper(
				data.link.method,
				data.link.url,
				null,
				null,
				user.token,
				null,
				{ disablePrefix: true }
			)

			await axiosWrapper(
				"POST",
				`expense/v2/${data.id}/plan/${data.targetPlan.id}/allocation`,
				{ amount: data.allocatedAmount },
				null,
				user.token
			)
		} else if (action === "DELETE") {
			await axiosWrapper(`DELETE`, `expense/${data.id}`, null, null, user.token)

			let msg = `Expense removed for ${data?.patient?.firstName} at ${data?.provider?.name}.`
			if (!data?.provider?.name || !data?.patient?.firstName) msg = "Expense removed."
			await store.setNotification("notification", true, {
				msg,
				severity: "success"
			})
		} else if (action === "UPDATE_EXPENSE_RECEIPT") {
			const { payload, params } = data
			const mediaToAddRequests = payload.mediaToAdd?.map((m) => {
				return axiosWrapper("POST", `expense/${params.id}/media`, null, m.file, user.token)
			})
			const mediaToDeleteRequests = payload.mediaToDelete?.map((m) => {
				return axiosWrapper("DELETE", `expense/${params.id}/media/${m.id}`, null, m.file, user.token)
			})
			await Promise.all([...(mediaToAddRequests || []), ...(mediaToDeleteRequests || [])])
		}

		if (history) history(-1)
		return newData
	} catch (err) {
		console.error(err)

		if (setMounted) {
			setMounted(true)
		}
	}
}

export default expense
